const employees = {
  headerButtons: {
    create: {
      createBtn: 'Create',
    },
  },

  edit: {
    tabs: {
      information: 'Information',
      history: 'History',
      bookingHistory: 'Booking History',
    }
  },

  table: {
    headers: {
      createBtn: 'Create',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      homeAddress: 'Home Address',
      workAddress: 'Work Address',
      createdAt: 'Created At',
      createdBy: 'Created By',
    },
  },
  form: {
    header: {
      create: {
        title: 'Create',
      },

      update: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    actions: {
      header: 'Actions',
      buttons: {
        resetPassword: 'Reset Password',
      },
    },

    sections: {
      profiles: {
        header: 'Profiles',
        fields: {
          profiles: {
            label: 'Profiles',
          },
          attributes: {
            label: 'Attributes'
          }
        },
      },
      personalDetails: {
        header: 'Personal Details',
        fields: {
          firstName: {
            label: 'First name',
          },
          lastName: {
            label: 'Last name',
          },
          email: {
            label: 'Email',
          },
          phone: {
            label: 'Phone',
          },
          additionalPhone: {
            label: 'Additional phone',
          },
        },
      },
      addresses: {
        header: 'Employee Addresses',
        fields: {
          workAddress: {
            label: 'Work Address',
          },
          homeAddress: {
            label: 'Home Address',
          },
          additionalHomeAddress: {
            label: 'Home Address 2',
          },
        },
      },
    },
  },

  create: {
    confirmButtonText: 'Submit',
    toasts: {
      success: 'Employee successfully created',
      error: 'An error occured while creating the parent',
    },
  },
  update: {
    activeStatus: {
      statusActive: 'Active',
      statusDeactivate: 'Inactive',
    },

    suspend: {
      actionActivate: 'Unsuspend',
      actionDeactivate: 'Suspend',
      suspendModal: {
        popupTitleDeactivation: 'Suspend Passenger',
        popupTitleActive: 'Suspend Reason',
        popupTitleUnsuspend: 'Unsuspend Reason',
        popupSubTitleDeactivation: 'Select the reason for the suspenssion',
        popupActionActive: 'Unsuspend Passenger',
        popupActionDeactivate: 'Suspend Passenger',
      },
    },
    toasts: {
      success: 'Parent successfully updated',
      error: 'An error occured while updating the parent',
      fetchError: 'Something went wrong, please try again.',
    },
  },
};

export default employees;
